import {Environment} from "platform/enum/Environment";

enum LSKey {

    LangCode = "__lang",
    Token = "__tkn",
    Theme = "__ctm",
    ChartSearch = "__crts",
    ServerToLocalhost = "__serverToLocalhost",
    TimeFormat = "__timeFormat",
    TrackLeadAttribution = "__trackLeadAttribution",
}

namespace LSKey {

    export function hasKey(key: string): boolean {
        for (const sk in LSKey) {
            if (LSKey[sk] === key) {
                return true;
            }
        }
        return false;
    }

    export function SelectedEnvironmentKey(): string {
        return `__UseEnv__${Environment.environment()}`;
    }
}

interface Storage {

    setItem(key: string, value: string): void;

    getItem(key: string): Promise<string | null>;

    removeItem(key: string): void;
}

export {
    LSKey, Storage
};
